<script setup>
import { ref } from 'vue';
import CmprModal from '@cta/frontend/components/CmprModal.vue';
import { localizeAmount } from '@cta/frontend/javascripts/money';

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  amount: {
    type: Number,
    default: undefined,
  },
});

const hidden = ref(false);
const emit = defineEmits(['abort']);

function abort() {
  if (hidden.value) return;

  emit('abort');
  hidden.value = true;
}
</script>

<template>
  <CmprModal
    class="resulting-amount-modal"
    :visible="visible && !hidden"
    @update:visible="abort"
  >
    <template #content>
      <p>
        Danke, dass Du Campact fördern möchtest!
        Du hast einen wöchentlichen Betrag von {{ localizeAmount(amount) }} ausgewählt.
        Das entspricht einer monatlichen Abbuchung von {{ localizeAmount(amount * 4) }}.
        Bei jährlicher Zahlung entspricht das einem Beitrag von {{ localizeAmount(amount * 52) }}.
        Ist das richtig?
      </p>
    </template>

    <template #footer>
      <cmpr-button
        data-analytics-id="sponsor-call-form-amount-overlay-abort-button"
        size="small"
        variant="secondary"
        @click.prevent="abort"
      >
        Nein, Betrag anpassen
      </cmpr-button>

      <cmpr-button
        data-analytics-id="sponsor-call-form-amount-overlay-commit-button"
        size="small"
        variant="tertiary"
        @click.prevent="hidden = true"
      >
        Ja, weiter zum nächsten Schritt
      </cmpr-button>
    </template>
  </CmprModal>
</template>
